export default __webpack_public_path__ + "cea7f9e60d704e3207ed9c3324acceee.svg";